import { createRouter, createWebHistory } from "vue-router";
import { languageService } from "@/utils";
import { languageEnum } from "@/enums/plugins/i18n";

const Home = () => import(/* webpackChunkName: "home" */ "@/components/home.vue");
const HomeExplorer = () => import(/* webpackChunkName: "home-explorer" */ "@/components/home-explorer.vue");
const Library = () => import(/* webpackChunkName: "library" */ "@/components/library");
const MasterClass = () => import(/* webpackChunkName: "master-class" */ "@/components/master-class");
const Bookmark = () => import(/* webpackChunkName: "bookmark" */ "@/components/bookmark");
const History = () => import(/* webpackChunkName: "bookmark" */ "@/components/history");
const OnlineManual = () => import(/* webpackChunkName: "online-manual" */ "@/components/online-manual");
const SkillPath = () => import(/* webpackChunkName: "skill-path" */ "@/components/skill-path");
const SkillPathDetail = () => import(/* webpackChunkName: "skill-path" */ "@/components/skill-path-detail");

const WebinarUpcoming = () => import(/* webpackChunkName: "webinar" */ "../components/webinar/upcoming.vue");
const WebinarArchive = () => import(/* webpackChunkName: "webinar" */ "../components/webinar/archive.vue");
const WebinarSpeaker = () => import(/* webpackChunkName: "webinar" */ "../components/webinar/speaker.vue");
const WebinarWrapper = () => import(/* webpackChunkName: "webinar" */ "../components/webinar/wrapper.vue");

const createMultiLangRoute = route => {
    let copyRouter = _.cloneDeep(route);
    if (copyRouter.children) {
        copyRouter.children.forEach(child => {
            if (child.name != undefined) {
                child.name += "-lang";
            }
            if (child.redirect != undefined) {
                child.redirect.name += "-lang"
            }
        })
    }
    return {
        ...copyRouter,
        path: "/:lang" + copyRouter.path,
        name: copyRouter.name + "-lang",
    };
};

const routerBeforeEach = (to, from, next) => {
    const { setLanguage, getLanguage, getTargetLanguagePath } = languageService;
    const lang = to.params.lang?.toLowerCase();
    let nextInfo;

    if (lang !== undefined) { 
        if (lang === languageEnum.EN) {
            const { params, query, hash } = to;

            delete params.lang;
            setLanguage(languageEnum.EN);
            nextInfo = { path: getTargetLanguagePath(languageEnum.EN), params, query, hash };
        }
        else if (Object.values(languageEnum).includes(lang)) {
            setLanguage(lang);
        }
        else {
            nextInfo = { name: "home" };
        }
    }
    else if (getLanguage() !== languageEnum.EN) {
        setLanguage(languageEnum.EN);
    }

    next(nextInfo);
};

let routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/home/:path+",
        name: "homeExplorer",
        component: HomeExplorer,
    },
    {
        path: "/library",
        name: "library",
        component: Library,
    },
    {
        path: "/master-class/:tab?/:category?/:path*",
        name: "masterClass",
        component: MasterClass,
    },
    {
        path: "/skill-paths",
        name: "skillPath",
        component: SkillPath,
    },
    {
        path: "/skill-paths/:urlName",
        name: "skillPathDetail",
        component: SkillPathDetail,
    },
    {
        path: "/webinar",
        name: "webinar",
        component: WebinarWrapper,
        children: [
            { path: "", redirect: { name: 'webinar-upcoming' } },
            { path: "upcoming", component: WebinarUpcoming, name: "webinar-upcoming" },
            { path: "speakerinfo", component: WebinarSpeaker, name: "webinar-speakerinfo" },
            { path: "archive", component: WebinarArchive, name: "webinar-archive" },
            { path: ":catchAll(.*)", redirect: { name: 'webinar-upcoming' } },
        ]
    },
    {
        path: "/bookmark",
        name: "bookmark",
        component: Bookmark,
    },
    {
        path: "/history",
        name: "history",
        component: History,
    },
    {
        path: "/online-manual",
        name: "onlineManual",
        component: OnlineManual,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        redirect: { name: "home" },
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [...routes, ...routes.map(createMultiLangRoute)],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) { // 當上一頁時回到轉跳前 position
            return savedPosition; 
        }
        if (to.hash) {
            return {
                el: to.hash, 
                top: 100, // offset
            }
        }
        else {
            return {  top: 0 }
        }
    }
})

router.beforeEach(routerBeforeEach);

export default router;
